import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots } from "vue";
const _hoisted_1 = { class: "pl-1" };
const _hoisted_2 = { class: "filter-button-list overflow-y-auto max-h-100 min-w-50" };
const _hoisted_3 = { class: "flex items-center gap-2 w-full" };
const _hoisted_4 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnFilterButtonBase"], {
        modelValue: $setup.menuIsVisible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.menuIsVisible) = $event)),
        id: $setup.returnFilterButtonId($props.id),
        "display-string": $setup.filterValue,
        "reset-filter": $setup.resetFilter,
        "is-action-buttons-rendered": false
    }, _createSlots({
        label: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (option, index) => {
                    return (_openBlock(), _createBlock($setup["MenuItem"], {
                        key: index,
                        value: option.Id,
                        class: _normalizeClass([{ 'bg-accent': $setup.isSelected(option) }, "min-h-8 mb-1"]),
                        onClick: () => $setup.handleSelectItem(index),
                        onSelect: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["prevent"]))
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                                ($setup.shouldHaveCheckbox(option))
                                    ? (_openBlock(), _createBlock($setup["EnCheckBox"], {
                                        key: 0,
                                        "model-value": $setup.isSelected(option),
                                        id: $setup.buildIdForElement(option),
                                        class: "select-item-checkbox ml-2",
                                        "hide-details": ""
                                    }, null, 8 /* PROPS */, ["model-value", "id"]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("div", {
                                    class: "grow truncate ml-2",
                                    id: $setup.shouldHaveCheckbox(option) ? undefined : $setup.buildIdForElement(option)
                                }, _toDisplayString($setup.optionTitle(option)), 9 /* TEXT, PROPS */, _hoisted_4)
                            ])
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "class", "onClick"]));
                }), 128 /* KEYED_FRAGMENT */))
            ])
        ]),
        _: 2 /* DYNAMIC */
    }, [
        ($setup.isMultipleSelected)
            ? {
                name: "display-string-suffix",
                fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, _toDisplayString($setup.t('common.dataGrid.selectedText')), 1 /* TEXT */)
                ]),
                key: "0"
            }
            : undefined
    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "id", "display-string", "reset-filter"]));
}
